import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { format, parseISO } from 'date-fns'; // Importer date-fns pour le formatage
import { fr } from 'date-fns/locale'; //Importer la locale française
import moment from 'moment';
import { FaUserCircle, FaUserTie } from 'react-icons/fa';
import { getAuthToken } from '../../authToken';

// Composant Commentaire
const Commentaire = ({ formulaire_id, user_id }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const commentEndRef = useRef(null);  // Référence pour le dernier commentaire/notification
  const isAdmin = false;
  const produit = "Eligibilite"
  const notification_id = localStorage.getItem('notification_id');
  const [formulaireUserId, setFormulaireUserId] = useState();

  // const fetchFormUser = useCallback(async () => {
  //   try {
  //     const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-eligibilite/${formulaire_id}/`);
  //     if (!response.ok) throw new Error('Erreur réseau');
  //     const data = await response.json();
  //     console.log('Données du formulaire récupérées Id:', data);

  //     // Récupérer l'ID de l'utilisateur à partir des données
  //     setFormulaireUserId(data.utilisateur.id);
  //     console.log('cest bon:', data.utilisateur.id);
  //   } catch (error) {
  //     console.error("L'utilisateur n'a probablement pas de formulaire enregistré:", error);
  //   }
  // }, [formulaire_id]);


  // Fonction pour charger les commentaires
  const fetchComments = useCallback(async () => {
    if (!formulaire_id) {
      console.log("formulaire_id pas encore disponible");
      return;  // Ne pas faire l'appel API tant que formulaire_id n'est pas disponible
    }
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-modifications-commentaires/${formulaire_id}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      // const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-modifications-commentaires/${formulaire_id}/`);
      const data = await response.json();
      setComments(data);
      console.log('liste coms', data);
      localStorage.setItem('formulaire_id', formulaire_id);
    } catch (error) {
      console.error('Erreur lors de la récupération des commentaires', error);
    }
  }, [formulaire_id]);  // Ajouter formulaire_id et l'id de l'utilisateur comme dépendance

  // Marquer une notification spécifique comme vue
  const marquerVu = useCallback(async () => {
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}//marquer-vu/${notification_id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          is_admin: isAdmin,
        }),
      });
      // const response = await fetch(`${process.env.REACT_APP_HOTE}/marquer-vu/${notification_id}/`, {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     is_admin: isAdmin,  // Passer isAdmin dans le corps de la requête
      //   }),
      // });

      if (!response.ok) {
        throw new Error('Erreur lors de la requête');
      }

      const data = await response.json();
      console.log('Notification marquée comme vue :', data);
    } catch (error) {
      console.error('Erreur dans marquerVu:', error);
    }
  }, [notification_id, isAdmin]);

  // Marquer toutes les notifications d'un formulaire comme vues
  const marquerToutesVues = useCallback(async () => {
    if (!formulaire_id) {
      console.log("formulaire_id pas encore disponible");
      return;  // Ne pas faire l'appel API tant que formulaire_id n'est pas disponible
    }
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/marquer-toutes-vues-eligibilite/${formulaire_id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          is_admin: isAdmin,  // Passer isAdmin dans le corps de la requête
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la requête');
      }

      const data = await response.json();
      console.log('Toutes les notifications marquées comme vues e :', data);
    } catch (error) {
      console.error('Erreur dans marquerToutesVu:', error);
    }

    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/marquer-toutes-vues/${formulaire_id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          is_admin: isAdmin,  // Passer isAdmin dans le corps de la requête
          produit: produit
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la requête');
      }

      const data = await response.json();
      console.log('Toutes les notifications marquées comme vues :', data);
    } catch (error) {
      console.error('Erreur dans marquerToutesVu:', error);
    }
  }, [formulaire_id, isAdmin, produit]);

  // Charger les commentaires au montage du composant
  useEffect(() => {
    marquerVu();
    marquerToutesVues();
    // fetchFormUser();
    fetchComments();  // Appel de la fonction lors du montage du composant
  }, [fetchComments, marquerVu, marquerToutesVues]);

  // // Fonction pour formater la date
  // const getFormattedDate = (dateString) => {
  //   const date = moment(dateString);
  //   const today = moment().startOf('day');
  //   const yesterday = moment().subtract(1, 'days').startOf('day');

  //   const formattedTime = format(parseISO(dateString), 'HH:mm', { locale: fr }); // Format de l'heure

  //   if (date.isSame(today, 'day')) {
  //     return `Aujourd'hui à ${formattedTime}`;
  //   } else if (date.isSame(yesterday, 'day')) {
  //     return `Hier à ${formattedTime}`;
  //   } else {
  //     return format(parseISO(dateString), 'dd MMMM yyyy à HH:mm', { locale: fr });
  //   }
  // };

  // Fonction pour formater la date
  const getFormattedDate = (dateString) => {
    const date = moment(dateString);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    // const formattedTime = format(parseISO(dateString), 'HH:mm', { locale: fr }); // Format de l'heure

    if (date.isSame(today, 'day')) {
      return `Aujourd'hui`;
    } else if (date.isSame(yesterday, 'day')) {
      return `Hier`;
    } else {
      return format(parseISO(dateString), 'dd MMMM yyyy', { locale: fr });
    }
  };

  // Fonction pour scroller vers le dernier commentaire
  const scrollerVersLeBas = () => {
    commentEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Utiliser useEffect pour scroller à chaque mise à jour des commentaires
  useEffect(() => {
    // scrollerVersLeBas();  // Scroll automatique vers le bas à chaque fois que les commentaires changent
  }, [comments]);

  const [showModal, setShowModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);

  const handleVoirChamps = (notificationMessage) => {
    setSelectedNotification(notificationMessage);
    setShowModal(true); // Affichez la modale
  };

  const handleClose = () => {
    setShowModal(false); // Fermez la modale 
    setSelectedNotification(null);
  };

  return (
    <div className="commentaire-container" style={{ justifyContent: "space-between", height: "100%" }}>
      {/* Liste des commentaires avec barre de défilement */}
      <div style={styles.commentListContainer}>
        {comments.length === 0 ? (
          <div>Aucun commentaire ou notification disponible.</div>
        ) : (
          // // Grouper les commentaires par date avant de les mapper
          // Object.entries(
          //   comments
          //     .filter((item) => !(item.action === "commente" && !item.commentaire))
          //     .reduce((groups, item) => {
          //       const dateKey = moment(item.date_action || item.date_commentaire).format("YYYY-MM-DD");
          //       if (!groups[dateKey]) groups[dateKey] = [];
          //       groups[dateKey].push(item);
          //       return groups;
          //     }, {})
          // )
          //   .reverse() // Réorganiser par date
          //   .map(([date, items]) => (
          //     <div key={date}>
          //       {/* Affichage de la date */}
          //       <div className="mt-1 mb-1" style={{ textAlign: "center", fontWeight: "bold", color: "#555" }}>
          //         {/* {moment(date).format("dddd DD MMMM YYYY")} */}
          //         {getFormattedDate(date)}
          //       </div>
          //       {/* Affichage des items de la date */}
          //       {items
          //         .reverse() // Pour que les derniers soient affichés en haut pour chaque date
          //         .map((item) => {
          //           const isNewComment = moment().diff(moment(item.date_commentaire), "minutes") < 5; // Considérer un commentaire comme nouveau s'il a moins de 5 minutes
          //           return (
          //             <div
          //               key={item.id}
          //               className="comment"
          //               style={{
          //                 ...item.notification_message ? styles.notification : styles.comment,
          //                 backgroundColor: isNewComment ? "#ffffff" : "#ffffff", // Couleur de fond différente pour les nouveaux commentaires
          //               }}
          //             >
          //               {/* Reste du rendu des notifications et commentaires */}
          //               {item.notification_message && item.action !== "commente" ? (


          // Grouper les commentaires par date avant de les mapper
          Object.entries(
            comments
              .filter((item) => !(item.action === "commente" && !item.commentaire))
              .reduce((groups, item) => {
                const dateKey = moment(item.date_action || item.date_commentaire).format("YYYY-MM-DD");
                if (!groups[dateKey]) groups[dateKey] = [];
                groups[dateKey].push(item);
                return groups;
              }, {})
          )
            .reverse() // Réorganiser par date
            .map(([date, items]) => (
              <div key={date}>
                {/* Affichage de la date */}
                <div className="mt-1 mb-1" style={{ textAlign: "center", fontWeight: "bold", color: "#555" }}>
                  {getFormattedDate(date)}
                </div>
                {/* Affichage des items de la date */}
                {items
                  .reverse() // Pour que les derniers soient affichés en haut pour chaque date
                  .map((item, index) => { // Utilisation de l'index local pour générer une clé unique
                    const uniqueKey = `${item.id}-${index}`; // Combiner id et index
                    const isNewComment = moment().diff(moment(item.date_commentaire), "minutes") < 5; // Considérer un commentaire comme nouveau s'il a moins de 5 minutes
                    return (
                      <div
                        key={uniqueKey} // Utiliser la clé unique ici
                        className="comment"
                        style={{
                          ...item.notification_message ? styles.notification : styles.comment,
                          backgroundColor: isNewComment ? "#ffffff" : "#ffffff", // Couleur de fond différente pour les nouveaux commentaires
                        }}
                      >
                        {/* Reste du rendu des notifications et commentaires */}
                        {item.notification_message && item.action !== "commente" ? (
                          <>
                            {item.action === "modifie" &&
                              item.notification_message !== "Le dossier d'Eligibilité a été resoumis sans modification." ? (
                              <div className="d-flex justify-content-end align-items-start">
                                <div
                                  className="pl-1 pr-1 ml-5 mb-1"
                                  style={{ backgroundColor: "#e0f7fa", borderRadius: "10px" }}
                                >
                                  <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserCircle size={15} className="mr-1" />
                                      <strong>Vous</strong>
                                    </span>
                                  </div>
                                  <div className="pb-1 ml-1">
                                    Le dossier d'Eligibilité a été modifié et est en attente d'approbation.
                                    <a
                                      onClick={() => handleVoirChamps(item.notification_message)}
                                      className="text-success"
                                    >
                                      Voir les champs modifiés
                                    </a>
                                  </div>
                                  <div className="d-flex justify-content-end align-items-end mb-1">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ) : item.action === "soumis" ? (
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="pl-1 pr-1 mb-1"
                                  style={{ backgroundColor: "#ffffff", borderRadius: "5px", border: "2px solid #e1e1e1" }}
                                >
                                  {/* <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserCircle size={15} className="mr-1" />
                                      <strong>Vous</strong>
                                    </span>
                                  </div> */}
                                  {/* <div className="pb-1 ml-1">{item.notification_message}</div> */}
                                  <small>{item.notification_message}</small>
                                  <div className="d-flex justify-content-end align-items-end">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ) : item.action === "a revoir" ? (
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="pl-1 pr-1 mb-1"
                                  style={{ backgroundColor: "#ffffff", borderRadius: "5px", border: "2px solid #e1e1e1" }}
                                >
                                  {/* <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserTie size={15} className="mr-1" />
                                      <strong>INOVACT</strong>
                                    </span>
                                  </div>
                                  <div className="pb-1 ml-1">{item.notification_message}</div> */}
                                  <small>{item.notification_message}</small>
                                  <div className="d-flex justify-content-end align-items-end">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ) : item.action === "valide" ? (
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="pl-1 pr-1 mb-1"
                                  style={{ backgroundColor: "#ffffff", borderRadius: "5px", border: "2px solid #e1e1e1" }}
                                >
                                  {/* <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserTie size={15} className="mr-1" />
                                      <strong>INOVACT</strong>
                                    </span>
                                  </div>
                                  <div className="pb-1 ml-1">{item.notification_message}</div> */}
                                  <small>{item.notification_message}</small>
                                  <div className="d-flex justify-content-end align-items-end">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              // Autres conditions pour les notifications et commentaires
                              <div className="d-flex justify-content-end align-items-end">
                                <div
                                  className="pl-1 pr-1 ml-5 mb-1"
                                  style={{ backgroundColor: "#e0f7fa", borderRadius: "10px" }}
                                >
                                  <div className="d-flex justify-content-start align-items-start mt-1 mb-1">
                                    <span className="d-flex justify-content-center align-items-center">
                                      <FaUserCircle size={13} className="mr-1" />
                                      <strong>Vous</strong>
                                    </span>
                                  </div>
                                  <div className="ml-1">{item.notification_message}</div>
                                  <div className="d-flex justify-content-end align-items-end mb-1">
                                    <small>
                                      {format(parseISO(item.date_action), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            {/* Affichage des commentaires */}
                            {item.commentaire && (
                              <div className="d-flex justify-content-start align-items-start">
                                <div
                                  className="pl-2 pr-2 mr-5 mb-1"
                                  style={{ backgroundColor: "#f5f5f5", borderRadius: "10px" }}
                                >
                                  <div className="d-flex justify-content-between align-items-center mt-1">
                                    <span className="d-flex justify-center align-items-center">
                                      <FaUserTie size={13} className="mr-1" />
                                      <strong>INOVACT</strong>
                                    </span>
                                  </div>
                                  {/* {item.commentaire} */}
                                  <span dangerouslySetInnerHTML={{ __html: item.commentaire }}></span>
                                  <div className="d-flex justify-content-end align-items-end mb-1">
                                    <small>
                                      {format(parseISO(item.date_commentaire), 'HH:mm', { locale: fr })}
                                    </small>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    );
                  })}
              </div>
            ))
        )}
        {/* Élément de fin pour déclencher le défilement */}
        <div ref={commentEndRef} />

        {/* Modale pour afficher les champs de modifications */}
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>Champs modifiés</Modal.Title>
          </Modal.Header>
          <Modal.Body>{selectedNotification}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

// Styles pour les notifications et les commentaires avec une barre de défilement
const styles = {
  commentListContainer: {
    maxHeight: '400px', // Hauteur maximale pour la zone des commentaires
    overflowY: 'auto',  // Activer le défilement vertical si le contenu dépasse la hauteur
  },
  notification: {
    padding: '2px',
    // borderTop: '1px solid #cfcfcf',
  },
  comment: {
    padding: '2px',
    // borderTop: '1px solid #cfcfcf',
  },
};

export default Commentaire;
